import { render, staticRenderFns } from "./LoaderWait.vue?vue&type=template&id=6f4e61db&scoped=true"
import script from "./LoaderWait.vue?vue&type=script&lang=js"
export * from "./LoaderWait.vue?vue&type=script&lang=js"
import style0 from "./LoaderWait.vue?vue&type=style&index=0&id=6f4e61db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4e61db",
  null
  
)

export default component.exports